import { useEffect } from 'react';

/**
 * Hook pre automatické scrollovanie formulárov na mobilných zariadeniach
 * Rieši problém, keď klávesnica zakryje spodné tlačidlá
 */
const useFormScrolling = () => {
  useEffect(() => {
    // Detekcia mobilného zariadenia
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    // Detekcia Facebook/Instagram WebView
    const isWebView = /FBAN|FBAV|Instagram|WebView/i.test(navigator.userAgent);
    
    // Ak nie je mobilné zariadenie, nemusíme nič robiť
    if (!isMobile) return;
    // Funkcia na scroll pri zameraní inputu
    const handleFocus = (e) => {
      // Krátke oneskorenie pre aktiváciu klávesnice
      setTimeout(() => {
        const focusedElement = e.target;
        const elementRect = focusedElement.getBoundingClientRect();
        
        // Zistíme, či je element čiastočne mimo obrazovky
        const isElementPartiallyVisible = 
          elementRect.bottom > window.innerHeight || 
          elementRect.top < 0;
        
        // Vypočítame pozíciu pre scrollovanie
        const y = elementRect.top + window.scrollY;
        
        // Rôzne offsety pre rôzne typy prehliadačov
        let offset = 150; // Základný offset
        if (isWebView) {
          offset = 200; // Väčší offset pre WebView, kde je viac UI elementov
        }
        
        // Scrollujeme iba ak je potrebné
        if (isElementPartiallyVisible) {
          window.scrollTo({ 
            top: y - offset, 
            behavior: 'smooth'
          });
        }
      }, 300);
    };
    
    // Funkcia na skrytie klávesnice pri kliknutí mimo vstupného poľa
    const handleBlur = () => {
      // Na iOS a Android musíme použiť aktívny element a blur()
      if (document.activeElement) {
        if (document.activeElement.tagName === 'INPUT' || 
            document.activeElement.tagName === 'TEXTAREA' || 
            document.activeElement.tagName === 'SELECT') {
          document.activeElement.blur();
        }
      }
    };
    
    // Funkcia na zachytenie kliknutia na tlačidlo na skrytie klávesnice
    const handleButtonClick = () => {
      // Skryjeme klávesnicu
      handleBlur();
      
      // Dáme čas na skrytie klávesnice a potom scrollujeme k tlačidlu
      setTimeout(() => {
        const clickedButton = document.activeElement;
        if (clickedButton && clickedButton.tagName === 'BUTTON') {
          const buttonRect = clickedButton.getBoundingClientRect();
          if (buttonRect.bottom > window.innerHeight) {
            window.scrollTo({
              top: window.scrollY + (buttonRect.bottom - window.innerHeight) + 20,
              behavior: 'smooth'
            });
          }
        }
      }, 200);
    };

    // Pridanie event listenerov pre všetky vstupné polia
    const inputs = document.querySelectorAll('input, textarea, select');
    inputs.forEach(input => {
      input.addEventListener('focus', handleFocus);
    });
    
    // Pridanie event listenerov pre všetky tlačidlá
    const buttons = document.querySelectorAll('button');
    buttons.forEach(button => {
      button.addEventListener('click', handleButtonClick);
    });
    
    // Pridanie event listenera na telo dokumentu pre odchytávanie kliknutí mimo vstupných polí
    document.body.addEventListener('click', (e) => {
      if (e.target.tagName !== 'INPUT' && 
          e.target.tagName !== 'TEXTAREA' && 
          e.target.tagName !== 'SELECT' && 
          e.target.tagName !== 'BUTTON') {
        handleBlur();
      }
    });

    // Cleanup
    return () => {
      inputs.forEach(input => {
        input.removeEventListener('focus', handleFocus);
      });
      
      buttons.forEach(button => {
        button.removeEventListener('click', handleButtonClick);
      });
      
      document.body.removeEventListener('click', handleBlur);
    };
  }, []);
};

export default useFormScrolling;
